/**
 * Mark components for the rich-text renderers in `components/Shared/RichText/Blog.tsx` and
 * `Simple.tsx`: each wraps a `text` node's content in a design-system `Typography` with one
 * style. A text node with several marks is wrapped once per mark, innermost first.
 */
import { ReactNode } from "react";
import { Typography } from "@ryerson/frontend.typography";
/** Renders the `bold` mark. */
export const Bold = ({ children }: { children: ReactNode }) => (
	<Typography weight="bold">{children}</Typography>
);
/** Renders the `italic` mark. */
export const Italic = ({ children }: { children: ReactNode }) => (
	<Typography italic>{children}</Typography>
);
/** Renders the `underline` mark. */
export const Underline = ({ children }: { children: ReactNode }) => (
	<Typography underline>{children}</Typography>
);
/** Unstyled span: the renderers use it for the `code` mark and any mark they don't recognise. */
export const Text = ({ children }: { children: ReactNode }) => (
	<Typography variant="span">{children}</Typography>
);
